import { planService } from '@/services'

export default {
  state: () => ({
    subscription: null,
    plans: [],
    stats: null,
    showLimitModal: false,
    typeLimitModal: 'spaces',
    invoices: null
  }),

  getters: {
    freePlan (state) {
      return state.plans.find(item => item.name === 'Free Plan')
    },

    trialPlan (state) {
      return state.plans.find(item => item.name === 'Trial Plan')
    },

    teamPlanMonthly (state) {
      return state.plans.find(item => item.name === 'Team Plan Monthly')
    },

    teamPlanYearly (state) {
      return state.plans.find(item => item.name === 'Team Plan Yearly')
    },

    proPlanMonthly (state) {
      return state.plans.find(item => item.name === 'Pro Plan Monthly')
    },

    proPlanYearly (state) {
      return state.plans.find(item => item.name === 'Pro Plan Yearly')
    },

    isFreePlan (state, getters) {
      return state.subscription?.planId === getters.freePlan?.id
    },

    isExpired (state, getters) {
      if (!state.subscription.expireAt) return false
      return new Date(state.subscription.expireAt) <= new Date() && !getters.isFreePlan
    },

    isTrialPlan (state, getters) {
      return state.subscription?.planId === getters.trialPlan.id
    },

    currentPlan (state) {
      return state.plans.find(item => item.id === state.subscription?.planId)
    },

    allowAddBook (state, getters) {
      const plan = getters.currentPlan
      const hasFree = getters.isExpired && state.stats?.books >= getters.freePlan.maxBooks

      return (plan?.maxBooks === -1 && !hasFree) || state.stats?.books < plan?.maxBooks
    },

    allowAddProject (state, getters) {
      const plan = getters.currentPlan
      const hasFree = getters.isExpired && state.stats?.projects >= getters.freePlan.maxProjects

      return (plan?.maxProjects === -1 && !hasFree) || state.stats?.projects < plan?.maxProjects
    },

    allowAddAttachments (state, getters) {
      return value => {
        const plan = getters.currentPlan
        const hasFree = getters.isExpired && state.stats?.size >= getters.freePlan.maxSize

        return (plan?.maxSize === -1 && !hasFree) || state.stats?.size + value < plan?.maxSize
      }
    }
  },

  mutations: {
    subscription (state, value) {
      state.subscription = value
    },

    plans (state, value) {
      state.plans = value
    },

    setStats (state, value) {
      state.stats = value
    },

    setInvoices (state, value) {
      state.invoices = value
    },

    toggleLimitModal (state, value) {
      state.showLimitModal = value.show
      state.typeLimitModal = value.type
    }
  },

  actions: {
    async getCurrentPlan ({ commit }) {
      commit('loading', true)
      return planService.getCurrentPlan().then(({ data }) => {
        commit('subscription', data)
        return data
      })
    },

    async getPlans ({ commit }) {
      commit('loading', true)
      return planService.getPlans().then(({ data }) => {
        commit('plans', data.plans)
        return data.plans
      })
    },

    async upgradePlan ({ commit }, { planId, userId }) {
      commit('loading', true)
      return planService.upgradePlan({ planId, userId })
        .then(({ data }) => {
          return data.id
        })
    },

    async upgradeTeamPlan ({ commit }, { planId, userId, teamId }) {
      commit('loading', true)
      return planService.upgradeTeamPlan({ planId, userId, teamId })
        .then(({ data }) => {
          return data.id
        })
    },

    async getInvoices ({ commit }) {
      commit('loading', true)
      planService.invoices().then(({ data }) => {
        commit('setInvoices', data.invoices)
      })
    },

    async stats ({ commit }) {
      return planService.stats().then(({ data }) => {
        commit('setStats', data)
      })
    }
  }
}
